<script setup>

import {onMounted, ref} from "vue";
import ButtonWithConfirmation from "../buttons/buttonWithConfirmation.vue";

const notifications = ref([])

const loadNotifications = async () => {
    const res = await axios.get(route('api.manage-whitelabel-app.notifications'))
    notifications.value = res.data.notification_schedules
}

const deleteNotification = async (notification) => {
    const res = await axios.delete(route('api.manage-whitelabel-app.delete-notification', notification.id))
    if (res.data.success) {
        await loadNotifications()
    }
}

onMounted(() => {
    loadNotifications()
})

defineExpose({loadNotifications})

</script>
<template>
    <div v-if="notifications.length > 0">
        <h2>{{ _mft('whitelabelApp:scheduledNotifications.title')}}</h2>
        <list-basic>
            <list-basic-item
                v-for="(notification, index) in notifications"
                :key="index"
            >
                <div class="text-xs font-bold">{{ notification.title }}</div>
                <div class="text-xs">{{ notification.body }}</div>
                <div class="mt-2 text-xs text-gray-400">{{ _mft('whitelabelApp:notification.scheduledAt') }} {{ notification.scheduled_at_user_tz_display }}</div>
                <template #actions>
                    <button-with-confirmation
                        size="sm"
                        @confirmed="deleteNotification(notification)"
                        :confirmButtonLabel="_mft('shared:confirm.continue')"
                        confirmButtonClass="myflow-basic-button--success whitespace-nowrap"
                        :confirm-text="_mft('shared:confirm.areYouSure')"
                    >
                        <i class="fa-regular fa-trash"></i>
                    </button-with-confirmation>
                </template>
            </list-basic-item>
        </list-basic>
    </div>
</template>
